module.exports = __webpack_public_path__ + "img/電気回路_6_4_1_old.91a6009d.png";